<template>

  <div class="centered-container">
    <md-content class="md-elevation-3">

      <h1 class="title md-display-1">
        Area riservata
      </h1>

      <div class="form">
        <md-field>
          <label>E-mail</label>
          <md-input v-model="login.email" autofocus></md-input>
        </md-field>

        <md-field md-has-password>
          <label>Password</label>
          <md-input v-model="login.password" type="password"></md-input>
        </md-field>
      </div>

      <md-button class="md-raised md-primary" @click="auth">Entra</md-button>

    </md-content>
  </div>

</template>

<script>

  export default {
    name: 'Login',
    data() {
      return {
        login: {
          email: '',
          password: ''
        }
      }
    },
    methods: {
      auth(e) {
        e.preventDefault()
        if (this.login.password.length > 0) {
          let loading = this.$loading.show();
          this.$http
            .post('/auth/logon', {
              email: this.login.email,
              password: this.login.password
            })
            .then(response => {
              loading.hide()
              if (response.data.done) {
                localStorage.setItem('user', JSON.stringify(response.data.data.user))
                this.$cookie.set('token', response.data.data.token)

                this.$emit('loggedIn')
                //this.$router.push('dashboard')
              } else {
                this.$fire({
                  text: response.data.message,
                  type: 'error'
                })
              }
            })
            .catch(function(error) {
              this.$fire({
                text: 'Errore di sistema',
                type: 'error'
              })
              console.error(error.response)
            })
        }
      }
    }
  }

</script>

<style>

  .centered-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 100vh;
    margin-top: -64px;
  }
  .title {
    text-align: center;
    margin-bottom: 30px;
    img {
      margin-bottom: 16px;
      max-width: 80px;
    }
  }
  .actions {
    .md-button {
      margin: 0;
    }
  }
  .form {
    margin-bottom: 60px;
  }
  .md-content {
    z-index: 1;
    padding: 40px;
    width: 100%;
    max-width: 400px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue